import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { ShipmentStatus } from '../api/types';

const STATUS_ICON: Record<ShipmentStatus, ReactNode> = {
  PENDING_PRICING: <ClockCircleOutlined />,
  POSTED: <CheckCircleOutlined />,
};

const STATUS_COLOR: Record<ShipmentStatus, string> = {
  PENDING_PRICING: 'gold',
  POSTED: 'green',
};

export function ShipmentStatusTag({ status }: { status: ShipmentStatus }): JSX.Element {
  const { t } = useTranslation();
  return (
    <Tag icon={STATUS_ICON[status]} color={STATUS_COLOR[status]} style={{ marginInlineEnd: 0 }}>
      {t(`shipments.status.${status}`)}
    </Tag>
  );
}
